import { StyledModalComponent } from '@dnhb/node_package';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { PrimaryOutlineButton } from '../buttons';
import { Loader } from '../components';
import { PdfFormRedux } from './';

const DownloadPdfButton = ({ app, settings, PdfForm = PdfFormRedux, ...props }) => {
  const { requireEmailBeforePDFDownload, requirePhonenumberBeforePDFDownload } = settings;
  const [showPdfForm, setShowPdfForm] = useState(false);
  const [formIsLoading, setFormIsLoading] = useState(false);
  const toolElement = useMemo(() => document.getElementById(`${app}-app`), [app]);
  const closeModal = () => setShowPdfForm(false);

  return (
    <>
      <PrimaryOutlineButton onClick={() => setShowPdfForm(true)}>
        {formIsLoading ? <Loader css={{ margin: 0 }} /> : 'Download het rapport'}
      </PrimaryOutlineButton>
      <StyledModalComponent
        appElement={toolElement}
        isOpen={showPdfForm}
        onRequestClose={formIsLoading ? () => {} : closeModal}
        maxWidth={540}
        showCross={false}
      >
        <PdfForm
          onRequestClose={() => setShowPdfForm(false)}
          app={app}
          requireEmail={requireEmailBeforePDFDownload}
          requirePhonenumber={requirePhonenumberBeforePDFDownload}
          formIsLoading={formIsLoading}
          setFormIsLoading={setFormIsLoading}
          {...props}
        />
      </StyledModalComponent>
    </>
  );
};

DownloadPdfButton.propTypes = {
  app: PropTypes.string.isRequired,
  settings: PropTypes.shape({}).isRequired,
  PdfForm: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default DownloadPdfButton;
